/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Works_Header_TaglineInputs */

const en_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects built with React, Astro, and modern technologies.`)
};

const ar_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاريع مبنية بـ React وAstro وأحدث التقنيات.`)
};

const bn_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, Astro ও আধুনিক টেক দিয়ে তৈরি প্রজেক্ট।`)
};

const de_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekte mit React, Astro und modernen Technologien.`)
};

const es_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyectos creados con React, Astro y tecnologías modernas.`)
};

const fr_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets réalisés avec React, Astro et des technologies modernes.`)
};

const pt_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projetos criados com React, Astro e tecnologias modernas.`)
};

const zh_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 React、Astro 和现代技术构建的项目。`)
};

const tr_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, Astro ve modern teknolojilerle oluşturulmuş projeler.`)
};

const ru_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проекты, созданные с использованием React, Astro и современных технологий.`)
};

const pl_works_header_tagline = /** @type {(inputs: Works_Header_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekty zbudowane w React, Astro i nowoczesnych technologiach.`)
};

/**
* | output |
* | --- |
* | "Projects built with React, Astro, and modern technologies." |
*
* @param {Works_Header_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const works_header_tagline = /** @type {((inputs?: Works_Header_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Works_Header_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_works_header_tagline(inputs)
	if (locale === "bn") return bn_works_header_tagline(inputs)
	if (locale === "de") return de_works_header_tagline(inputs)
	if (locale === "es") return es_works_header_tagline(inputs)
	if (locale === "fr") return fr_works_header_tagline(inputs)
	if (locale === "pt") return pt_works_header_tagline(inputs)
	if (locale === "zh") return zh_works_header_tagline(inputs)
	if (locale === "tr") return tr_works_header_tagline(inputs)
	if (locale === "ru") return ru_works_header_tagline(inputs)
	if (locale === "pl") return pl_works_header_tagline(inputs)
	return en_works_header_tagline(inputs)
});